module.exports = __webpack_public_path__ + "img/product_4.17e8bd7.webp";